"use strict";

var _typeof3 = require("@babel/runtime-corejs2/helpers/typeof");
var _Object$keys = require("@babel/runtime-corejs2/core-js/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors");
var _Object$defineProperties = require("@babel/runtime-corejs2/core-js/object/define-properties");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.createBaseOperations = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/typeof"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));
var _entries = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/entries"));
var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));
var _axios = _interopRequireDefault(require("axios"));
var _ = _interopRequireWildcard(require("lodash"));
var _fastJsonPatch = require("fast-json-patch");
var _qs = _interopRequireDefault(require("qs"));
var _config = _interopRequireDefault(require("./_config"));
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof3(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function cov_vpxeygri4() {
  var path = "/home/node/project/src/_api.js";
  var hash = "6bc0a46e9b51ebf6d8fabdd6e0baab12f147456d";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/node/project/src/_api.js",
    statementMap: {
      "0": {
        start: {
          line: 8,
          column: 12
        },
        end: {
          line: 8,
          column: 14
        }
      },
      "1": {
        start: {
          line: 10,
          column: 0
        },
        end: {
          line: 10,
          column: 18
        }
      },
      "2": {
        start: {
          line: 11,
          column: 0
        },
        end: {
          line: 11,
          column: 20
        }
      },
      "3": {
        start: {
          line: 12,
          column: 0
        },
        end: {
          line: 12,
          column: 38
        }
      },
      "4": {
        start: {
          line: 14,
          column: 0
        },
        end: {
          line: 14,
          column: 94
        }
      },
      "5": {
        start: {
          line: 14,
          column: 44
        },
        end: {
          line: 14,
          column: 93
        }
      },
      "6": {
        start: {
          line: 18,
          column: 15
        },
        end: {
          line: 18,
          column: 60
        }
      },
      "7": {
        start: {
          line: 18,
          column: 23
        },
        end: {
          line: 18,
          column: 60
        }
      },
      "8": {
        start: {
          line: 20,
          column: 24
        },
        end: {
          line: 30,
          column: 22
        }
      },
      "9": {
        start: {
          line: 20,
          column: 45
        },
        end: {
          line: 30,
          column: 22
        }
      },
      "10": {
        start: {
          line: 21,
          column: 2
        },
        end: {
          line: 23,
          column: 3
        }
      },
      "11": {
        start: {
          line: 22,
          column: 4
        },
        end: {
          line: 22,
          column: 31
        }
      },
      "12": {
        start: {
          line: 25,
          column: 2
        },
        end: {
          line: 28,
          column: 3
        }
      },
      "13": {
        start: {
          line: 27,
          column: 4
        },
        end: {
          line: 27,
          column: 48
        }
      },
      "14": {
        start: {
          line: 29,
          column: 2
        },
        end: {
          line: 29,
          column: 13
        }
      },
      "15": {
        start: {
          line: 32,
          column: 24
        },
        end: {
          line: 49,
          column: 1
        }
      },
      "16": {
        start: {
          line: 33,
          column: 30
        },
        end: {
          line: 43,
          column: 3
        }
      },
      "17": {
        start: {
          line: 35,
          column: 6
        },
        end: {
          line: 39,
          column: 7
        }
      },
      "18": {
        start: {
          line: 36,
          column: 8
        },
        end: {
          line: 36,
          column: 68
        }
      },
      "19": {
        start: {
          line: 37,
          column: 13
        },
        end: {
          line: 39,
          column: 7
        }
      },
      "20": {
        start: {
          line: 38,
          column: 8
        },
        end: {
          line: 38,
          column: 32
        }
      },
      "21": {
        start: {
          line: 40,
          column: 6
        },
        end: {
          line: 40,
          column: 17
        }
      },
      "22": {
        start: {
          line: 44,
          column: 26
        },
        end: {
          line: 47,
          column: 5
        }
      },
      "23": {
        start: {
          line: 44,
          column: 44
        },
        end: {
          line: 47,
          column: 3
        }
      },
      "24": {
        start: {
          line: 48,
          column: 2
        },
        end: {
          line: 48,
          column: 25
        }
      },
      "25": {
        start: {
          line: 53,
          column: 0
        },
        end: {
          line: 81,
          column: 2
        }
      },
      "26": {
        start: {
          line: 54,
          column: 18
        },
        end: {
          line: 54,
          column: 43
        }
      },
      "27": {
        start: {
          line: 55,
          column: 14
        },
        end: {
          line: 55,
          column: 26
        }
      },
      "28": {
        start: {
          line: 56,
          column: 19
        },
        end: {
          line: 56,
          column: 59
        }
      },
      "29": {
        start: {
          line: 58,
          column: 2
        },
        end: {
          line: 73,
          column: 3
        }
      },
      "30": {
        start: {
          line: 60,
          column: 27
        },
        end: {
          line: 60,
          column: 29
        }
      },
      "31": {
        start: {
          line: 61,
          column: 22
        },
        end: {
          line: 61,
          column: 35
        }
      },
      "32": {
        start: {
          line: 62,
          column: 4
        },
        end: {
          line: 66,
          column: 5
        }
      },
      "33": {
        start: {
          line: 62,
          column: 17
        },
        end: {
          line: 62,
          column: 18
        }
      },
      "34": {
        start: {
          line: 63,
          column: 19
        },
        end: {
          line: 63,
          column: 58
        }
      },
      "35": {
        start: {
          line: 65,
          column: 6
        },
        end: {
          line: 65,
          column: 65
        }
      },
      "36": {
        start: {
          line: 68,
          column: 24
        },
        end: {
          line: 70,
          column: 5
        }
      },
      "37": {
        start: {
          line: 69,
          column: 31
        },
        end: {
          line: 69,
          column: 44
        }
      },
      "38": {
        start: {
          line: 71,
          column: 4
        },
        end: {
          line: 71,
          column: 75
        }
      },
      "39": {
        start: {
          line: 71,
          column: 50
        },
        end: {
          line: 71,
          column: 64
        }
      },
      "40": {
        start: {
          line: 72,
          column: 4
        },
        end: {
          line: 72,
          column: 36
        }
      },
      "41": {
        start: {
          line: 75,
          column: 2
        },
        end: {
          line: 78,
          column: 3
        }
      },
      "42": {
        start: {
          line: 77,
          column: 4
        },
        end: {
          line: 77,
          column: 67
        }
      },
      "43": {
        start: {
          line: 80,
          column: 2
        },
        end: {
          line: 80,
          column: 18
        }
      },
      "44": {
        start: {
          line: 83,
          column: 0
        },
        end: {
          line: 90,
          column: 2
        }
      },
      "45": {
        start: {
          line: 88,
          column: 14
        },
        end: {
          line: 88,
          column: 26
        }
      },
      "46": {
        start: {
          line: 89,
          column: 2
        },
        end: {
          line: 89,
          column: 54
        }
      },
      "47": {
        start: {
          line: 92,
          column: 0
        },
        end: {
          line: 112,
          column: 2
        }
      },
      "48": {
        start: {
          line: 99,
          column: 14
        },
        end: {
          line: 99,
          column: 37
        }
      },
      "49": {
        start: {
          line: 101,
          column: 22
        },
        end: {
          line: 101,
          column: 123
        }
      },
      "50": {
        start: {
          line: 103,
          column: 2
        },
        end: {
          line: 105,
          column: 3
        }
      },
      "51": {
        start: {
          line: 104,
          column: 4
        },
        end: {
          line: 104,
          column: 76
        }
      },
      "52": {
        start: {
          line: 107,
          column: 15
        },
        end: {
          line: 110,
          column: 3
        }
      },
      "53": {
        start: {
          line: 111,
          column: 2
        },
        end: {
          line: 111,
          column: 44
        }
      },
      "54": {
        start: {
          line: 114,
          column: 0
        },
        end: {
          line: 114,
          column: 103
        }
      },
      "55": {
        start: {
          line: 114,
          column: 55
        },
        end: {
          line: 114,
          column: 102
        }
      },
      "56": {
        start: {
          line: 116,
          column: 0
        },
        end: {
          line: 116,
          column: 63
        }
      },
      "57": {
        start: {
          line: 116,
          column: 32
        },
        end: {
          line: 116,
          column: 62
        }
      },
      "58": {
        start: {
          line: 120,
          column: 36
        },
        end: {
          line: 133,
          column: 2
        }
      },
      "59": {
        start: {
          line: 120,
          column: 45
        },
        end: {
          line: 133,
          column: 1
        }
      },
      "60": {
        start: {
          line: 121,
          column: 17
        },
        end: {
          line: 121,
          column: 38
        }
      },
      "61": {
        start: {
          line: 122,
          column: 27
        },
        end: {
          line: 122,
          column: 59
        }
      },
      "62": {
        start: {
          line: 123,
          column: 34
        },
        end: {
          line: 123,
          column: 72
        }
      },
      "63": {
        start: {
          line: 125,
          column: 26
        },
        end: {
          line: 125,
          column: 58
        }
      },
      "64": {
        start: {
          line: 126,
          column: 26
        },
        end: {
          line: 126,
          column: 54
        }
      },
      "65": {
        start: {
          line: 127,
          column: 33
        },
        end: {
          line: 127,
          column: 72
        }
      },
      "66": {
        start: {
          line: 128,
          column: 41
        },
        end: {
          line: 128,
          column: 86
        }
      },
      "67": {
        start: {
          line: 129,
          column: 45
        },
        end: {
          line: 129,
          column: 92
        }
      },
      "68": {
        start: {
          line: 130,
          column: 56
        },
        end: {
          line: 130,
          column: 114
        }
      },
      "69": {
        start: {
          line: 131,
          column: 26
        },
        end: {
          line: 131,
          column: 54
        }
      },
      "70": {
        start: {
          line: 132,
          column: 37
        },
        end: {
          line: 132,
          column: 76
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 14,
            column: 34
          },
          end: {
            line: 14,
            column: 35
          }
        },
        loc: {
          start: {
            line: 14,
            column: 44
          },
          end: {
            line: 14,
            column: 93
          }
        },
        line: 14
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 18,
            column: 15
          },
          end: {
            line: 18,
            column: 16
          }
        },
        loc: {
          start: {
            line: 18,
            column: 23
          },
          end: {
            line: 18,
            column: 60
          }
        },
        line: 18
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 20,
            column: 24
          },
          end: {
            line: 20,
            column: 25
          }
        },
        loc: {
          start: {
            line: 20,
            column: 45
          },
          end: {
            line: 30,
            column: 22
          }
        },
        line: 20
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 20,
            column: 74
          },
          end: {
            line: 20,
            column: 75
          }
        },
        loc: {
          start: {
            line: 20,
            column: 97
          },
          end: {
            line: 30,
            column: 1
          }
        },
        line: 20
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 32,
            column: 24
          },
          end: {
            line: 32,
            column: 25
          }
        },
        loc: {
          start: {
            line: 32,
            column: 37
          },
          end: {
            line: 49,
            column: 1
          }
        },
        line: 32
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 34,
            column: 4
          },
          end: {
            line: 34,
            column: 5
          }
        },
        loc: {
          start: {
            line: 34,
            column: 25
          },
          end: {
            line: 41,
            column: 5
          }
        },
        line: 34
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 44,
            column: 38
          },
          end: {
            line: 44,
            column: 39
          }
        },
        loc: {
          start: {
            line: 44,
            column: 44
          },
          end: {
            line: 47,
            column: 3
          }
        },
        line: 44
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 53,
            column: 10
          },
          end: {
            line: 53,
            column: 11
          }
        },
        loc: {
          start: {
            line: 53,
            column: 83
          },
          end: {
            line: 81,
            column: 1
          }
        },
        line: 53
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 69,
            column: 25
          },
          end: {
            line: 69,
            column: 26
          }
        },
        loc: {
          start: {
            line: 69,
            column: 31
          },
          end: {
            line: 69,
            column: 44
          }
        },
        line: 69
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 71,
            column: 45
          },
          end: {
            line: 71,
            column: 46
          }
        },
        loc: {
          start: {
            line: 71,
            column: 50
          },
          end: {
            line: 71,
            column: 64
          }
        },
        line: 71
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 83,
            column: 11
          },
          end: {
            line: 83,
            column: 12
          }
        },
        loc: {
          start: {
            line: 87,
            column: 5
          },
          end: {
            line: 90,
            column: 1
          }
        },
        line: 87
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 92,
            column: 12
          },
          end: {
            line: 92,
            column: 13
          }
        },
        loc: {
          start: {
            line: 98,
            column: 5
          },
          end: {
            line: 112,
            column: 1
          }
        },
        line: 98
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 114,
            column: 13
          },
          end: {
            line: 114,
            column: 14
          }
        },
        loc: {
          start: {
            line: 114,
            column: 55
          },
          end: {
            line: 114,
            column: 102
          }
        },
        line: 114
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 116,
            column: 15
          },
          end: {
            line: 116,
            column: 16
          }
        },
        loc: {
          start: {
            line: 116,
            column: 32
          },
          end: {
            line: 116,
            column: 62
          }
        },
        line: 116
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 120,
            column: 36
          },
          end: {
            line: 120,
            column: 37
          }
        },
        loc: {
          start: {
            line: 120,
            column: 45
          },
          end: {
            line: 133,
            column: 1
          }
        },
        line: 120
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 121,
            column: 7
          },
          end: {
            line: 121,
            column: 8
          }
        },
        loc: {
          start: {
            line: 121,
            column: 17
          },
          end: {
            line: 121,
            column: 38
          }
        },
        line: 121
      },
      "16": {
        name: "(anonymous_16)",
        decl: {
          start: {
            line: 122,
            column: 11
          },
          end: {
            line: 122,
            column: 12
          }
        },
        loc: {
          start: {
            line: 122,
            column: 27
          },
          end: {
            line: 122,
            column: 59
          }
        },
        line: 122
      },
      "17": {
        name: "(anonymous_17)",
        decl: {
          start: {
            line: 123,
            column: 14
          },
          end: {
            line: 123,
            column: 15
          }
        },
        loc: {
          start: {
            line: 123,
            column: 34
          },
          end: {
            line: 123,
            column: 72
          }
        },
        line: 123
      },
      "18": {
        name: "(anonymous_18)",
        decl: {
          start: {
            line: 125,
            column: 10
          },
          end: {
            line: 125,
            column: 11
          }
        },
        loc: {
          start: {
            line: 125,
            column: 26
          },
          end: {
            line: 125,
            column: 58
          }
        },
        line: 125
      },
      "19": {
        name: "(anonymous_19)",
        decl: {
          start: {
            line: 126,
            column: 8
          },
          end: {
            line: 126,
            column: 9
          }
        },
        loc: {
          start: {
            line: 126,
            column: 26
          },
          end: {
            line: 126,
            column: 54
          }
        },
        line: 126
      },
      "20": {
        name: "(anonymous_20)",
        decl: {
          start: {
            line: 127,
            column: 11
          },
          end: {
            line: 127,
            column: 12
          }
        },
        loc: {
          start: {
            line: 127,
            column: 33
          },
          end: {
            line: 127,
            column: 72
          }
        },
        line: 127
      },
      "21": {
        name: "(anonymous_21)",
        decl: {
          start: {
            line: 128,
            column: 15
          },
          end: {
            line: 128,
            column: 16
          }
        },
        loc: {
          start: {
            line: 128,
            column: 41
          },
          end: {
            line: 128,
            column: 86
          }
        },
        line: 128
      },
      "22": {
        name: "(anonymous_22)",
        decl: {
          start: {
            line: 129,
            column: 9
          },
          end: {
            line: 129,
            column: 10
          }
        },
        loc: {
          start: {
            line: 129,
            column: 45
          },
          end: {
            line: 129,
            column: 92
          }
        },
        line: 129
      },
      "23": {
        name: "(anonymous_23)",
        decl: {
          start: {
            line: 130,
            column: 16
          },
          end: {
            line: 130,
            column: 17
          }
        },
        loc: {
          start: {
            line: 130,
            column: 56
          },
          end: {
            line: 130,
            column: 114
          }
        },
        line: 130
      },
      "24": {
        name: "(anonymous_24)",
        decl: {
          start: {
            line: 131,
            column: 10
          },
          end: {
            line: 131,
            column: 11
          }
        },
        loc: {
          start: {
            line: 131,
            column: 26
          },
          end: {
            line: 131,
            column: 54
          }
        },
        line: 131
      },
      "25": {
        name: "(anonymous_25)",
        decl: {
          start: {
            line: 132,
            column: 17
          },
          end: {
            line: 132,
            column: 18
          }
        },
        loc: {
          start: {
            line: 132,
            column: 37
          },
          end: {
            line: 132,
            column: 76
          }
        },
        line: 132
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 21,
            column: 2
          },
          end: {
            line: 23,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 21,
            column: 2
          },
          end: {
            line: 23,
            column: 3
          }
        }, {
          start: {
            line: 21,
            column: 2
          },
          end: {
            line: 23,
            column: 3
          }
        }],
        line: 21
      },
      "1": {
        loc: {
          start: {
            line: 25,
            column: 2
          },
          end: {
            line: 28,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 25,
            column: 2
          },
          end: {
            line: 28,
            column: 3
          }
        }, {
          start: {
            line: 25,
            column: 2
          },
          end: {
            line: 28,
            column: 3
          }
        }],
        line: 25
      },
      "2": {
        loc: {
          start: {
            line: 35,
            column: 6
          },
          end: {
            line: 39,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 35,
            column: 6
          },
          end: {
            line: 39,
            column: 7
          }
        }, {
          start: {
            line: 35,
            column: 6
          },
          end: {
            line: 39,
            column: 7
          }
        }],
        line: 35
      },
      "3": {
        loc: {
          start: {
            line: 37,
            column: 13
          },
          end: {
            line: 39,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 37,
            column: 13
          },
          end: {
            line: 39,
            column: 7
          }
        }, {
          start: {
            line: 37,
            column: 13
          },
          end: {
            line: 39,
            column: 7
          }
        }],
        line: 37
      },
      "4": {
        loc: {
          start: {
            line: 53,
            column: 23
          },
          end: {
            line: 53,
            column: 78
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 53,
            column: 76
          },
          end: {
            line: 53,
            column: 78
          }
        }],
        line: 53
      },
      "5": {
        loc: {
          start: {
            line: 53,
            column: 25
          },
          end: {
            line: 53,
            column: 36
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 53,
            column: 34
          },
          end: {
            line: 53,
            column: 36
          }
        }],
        line: 53
      },
      "6": {
        loc: {
          start: {
            line: 53,
            column: 38
          },
          end: {
            line: 53,
            column: 51
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 53,
            column: 47
          },
          end: {
            line: 53,
            column: 51
          }
        }],
        line: 53
      },
      "7": {
        loc: {
          start: {
            line: 53,
            column: 53
          },
          end: {
            line: 53,
            column: 71
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 53,
            column: 62
          },
          end: {
            line: 53,
            column: 71
          }
        }],
        line: 53
      },
      "8": {
        loc: {
          start: {
            line: 58,
            column: 2
          },
          end: {
            line: 73,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 58,
            column: 2
          },
          end: {
            line: 73,
            column: 3
          }
        }, {
          start: {
            line: 58,
            column: 2
          },
          end: {
            line: 73,
            column: 3
          }
        }],
        line: 58
      },
      "9": {
        loc: {
          start: {
            line: 58,
            column: 6
          },
          end: {
            line: 58,
            column: 73
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 58,
            column: 6
          },
          end: {
            line: 58,
            column: 12
          }
        }, {
          start: {
            line: 58,
            column: 16
          },
          end: {
            line: 58,
            column: 37
          }
        }, {
          start: {
            line: 58,
            column: 41
          },
          end: {
            line: 58,
            column: 73
          }
        }],
        line: 58
      },
      "10": {
        loc: {
          start: {
            line: 75,
            column: 2
          },
          end: {
            line: 78,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 75,
            column: 2
          },
          end: {
            line: 78,
            column: 3
          }
        }, {
          start: {
            line: 75,
            column: 2
          },
          end: {
            line: 78,
            column: 3
          }
        }],
        line: 75
      },
      "11": {
        loc: {
          start: {
            line: 85,
            column: 2
          },
          end: {
            line: 85,
            column: 22
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 85,
            column: 20
          },
          end: {
            line: 85,
            column: 22
          }
        }],
        line: 85
      },
      "12": {
        loc: {
          start: {
            line: 86,
            column: 2
          },
          end: {
            line: 86,
            column: 22
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 86,
            column: 20
          },
          end: {
            line: 86,
            column: 22
          }
        }],
        line: 86
      },
      "13": {
        loc: {
          start: {
            line: 86,
            column: 4
          },
          end: {
            line: 86,
            column: 15
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 86,
            column: 13
          },
          end: {
            line: 86,
            column: 15
          }
        }],
        line: 86
      },
      "14": {
        loc: {
          start: {
            line: 95,
            column: 2
          },
          end: {
            line: 95,
            column: 22
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 95,
            column: 20
          },
          end: {
            line: 95,
            column: 22
          }
        }],
        line: 95
      },
      "15": {
        loc: {
          start: {
            line: 97,
            column: 2
          },
          end: {
            line: 97,
            column: 28
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 97,
            column: 26
          },
          end: {
            line: 97,
            column: 28
          }
        }],
        line: 97
      },
      "16": {
        loc: {
          start: {
            line: 97,
            column: 4
          },
          end: {
            line: 97,
            column: 15
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 97,
            column: 13
          },
          end: {
            line: 97,
            column: 15
          }
        }],
        line: 97
      },
      "17": {
        loc: {
          start: {
            line: 101,
            column: 22
          },
          end: {
            line: 101,
            column: 123
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 101,
            column: 83
          },
          end: {
            line: 101,
            column: 116
          }
        }, {
          start: {
            line: 101,
            column: 119
          },
          end: {
            line: 101,
            column: 123
          }
        }],
        line: 101
      },
      "18": {
        loc: {
          start: {
            line: 101,
            column: 22
          },
          end: {
            line: 101,
            column: 80
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 101,
            column: 22
          },
          end: {
            line: 101,
            column: 43
          }
        }, {
          start: {
            line: 101,
            column: 47
          },
          end: {
            line: 101,
            column: 80
          }
        }],
        line: 101
      },
      "19": {
        loc: {
          start: {
            line: 103,
            column: 2
          },
          end: {
            line: 105,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 103,
            column: 2
          },
          end: {
            line: 105,
            column: 3
          }
        }, {
          start: {
            line: 103,
            column: 2
          },
          end: {
            line: 105,
            column: 3
          }
        }],
        line: 103
      },
      "20": {
        loc: {
          start: {
            line: 114,
            column: 30
          },
          end: {
            line: 114,
            column: 50
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 114,
            column: 48
          },
          end: {
            line: 114,
            column: 50
          }
        }],
        line: 114
      },
      "21": {
        loc: {
          start: {
            line: 114,
            column: 32
          },
          end: {
            line: 114,
            column: 43
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 114,
            column: 41
          },
          end: {
            line: 114,
            column: 43
          }
        }],
        line: 114
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0],
      "5": [0],
      "6": [0],
      "7": [0],
      "8": [0, 0],
      "9": [0, 0, 0],
      "10": [0, 0],
      "11": [0],
      "12": [0],
      "13": [0],
      "14": [0],
      "15": [0],
      "16": [0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0],
      "21": [0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "6bc0a46e9b51ebf6d8fabdd6e0baab12f147456d"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_vpxeygri4 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_vpxeygri4();
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; } /* eslint-disable arrow-parens */
var Api = (cov_vpxeygri4().s[0]++, {});
cov_vpxeygri4().s[1]++;
Api.axios = _axios["default"];
cov_vpxeygri4().s[2]++;
Api.config = _config["default"];
cov_vpxeygri4().s[3]++;
Api.interceptors = _axios["default"].interceptors;
cov_vpxeygri4().s[4]++;
_axios["default"].defaults.paramsSerializer = function (params) {
  cov_vpxeygri4().f[0]++;
  cov_vpxeygri4().s[5]++;
  return _qs["default"].stringify(params, {
    arrayFormat: 'brackets'
  });
};

/* ***** HELPERS ****** */
cov_vpxeygri4().s[6]++;
var getUrl = function getUrl(path) {
  cov_vpxeygri4().f[1]++;
  cov_vpxeygri4().s[7]++;
  return "".concat(Api.config.get('rootUrl')).concat(path);
};
cov_vpxeygri4().s[8]++;
var _resolveIncludes = function resolveIncludes(match, includes) {
  cov_vpxeygri4().f[2]++;
  cov_vpxeygri4().s[9]++;
  return (0, _entries["default"])(match).reduce(function (acc, _ref) {
    var _ref2 = (0, _slicedToArray2["default"])(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];
    cov_vpxeygri4().f[3]++;
    cov_vpxeygri4().s[10]++;
    if (includes[value]) {
      cov_vpxeygri4().b[0][0]++;
      cov_vpxeygri4().s[11]++;
      acc[key] = includes[value];
    } else {
      cov_vpxeygri4().b[0][1]++;
    }
    cov_vpxeygri4().s[12]++;
    if ((0, _typeof2["default"])(value) === 'object') {
      cov_vpxeygri4().b[1][0]++;
      cov_vpxeygri4().s[13]++;
      // object OR array
      acc[key] = _resolveIncludes(value, includes);
    } else {
      cov_vpxeygri4().b[1][1]++;
    }
    cov_vpxeygri4().s[14]++;
    return acc;
  }, _.cloneDeep(match));
};
cov_vpxeygri4().s[15]++;
var parseApiInclude = function parseApiInclude(entries) {
  cov_vpxeygri4().f[4]++;
  var _ref3 = (cov_vpxeygri4().s[16]++, entries.reduce(function (acc, currentVal) {
      cov_vpxeygri4().f[5]++;
      cov_vpxeygri4().s[17]++;
      if (currentVal.search.mode === 'include') {
        cov_vpxeygri4().b[2][0]++;
        cov_vpxeygri4().s[18]++;
        acc[0][currentVal.resource.reference] = currentVal.resource;
      } else {
        cov_vpxeygri4().b[2][1]++;
        cov_vpxeygri4().s[19]++;
        if (currentVal.search.mode === 'match') {
          cov_vpxeygri4().b[3][0]++;
          cov_vpxeygri4().s[20]++;
          acc[1].push(currentVal);
        } else {
          cov_vpxeygri4().b[3][1]++;
        }
      }
      cov_vpxeygri4().s[21]++;
      return acc;
    }, [{}, []])),
    _ref4 = (0, _slicedToArray2["default"])(_ref3, 2),
    includes = _ref4[0],
    matches = _ref4[1];
  var resolvedMatches = (cov_vpxeygri4().s[22]++, matches.map(function (e) {
    cov_vpxeygri4().f[6]++;
    cov_vpxeygri4().s[23]++;
    return _objectSpread(_objectSpread({}, e), {}, {
      resource: _resolveIncludes(e.resource, includes)
    });
  }));
  cov_vpxeygri4().s[24]++;
  return resolvedMatches;
};

/* ***** MAIN ****** */
cov_vpxeygri4().s[25]++;
Api.get = /*#__PURE__*/function () {
  var _ref5 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(path) {
    var _ref6,
      _ref6$params,
      params,
      _ref6$paging,
      paging,
      _ref6$signal,
      signal,
      rootUrl,
      url,
      response,
      paginationUrls,
      _ref7,
      entries,
      i,
      href,
      pageResults,
      _args = arguments;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _ref6 = _args.length > 1 && _args[1] !== undefined ? _args[1] : (cov_vpxeygri4().b[4][0]++, {}), _ref6$params = _ref6.params, params = _ref6$params === void 0 ? (cov_vpxeygri4().b[5][0]++, {}) : _ref6$params, _ref6$paging = _ref6.paging, paging = _ref6$paging === void 0 ? (cov_vpxeygri4().b[6][0]++, true) : _ref6$paging, _ref6$signal = _ref6.signal, signal = _ref6$signal === void 0 ? (cov_vpxeygri4().b[7][0]++, undefined) : _ref6$signal;
          cov_vpxeygri4().f[7]++;
          rootUrl = (cov_vpxeygri4().s[26]++, Api.config.get('rootUrl'));
          url = (cov_vpxeygri4().s[27]++, getUrl(path));
          cov_vpxeygri4().s[28]++;
          _context.next = 7;
          return _axios["default"].get(url, {
            params: params,
            signal: signal
          });
        case 7:
          response = _context.sent;
          cov_vpxeygri4().s[29]++;
          if (!((cov_vpxeygri4().b[9][0]++, paging) && (cov_vpxeygri4().b[9][1]++, response.data.entries) && (cov_vpxeygri4().b[9][2]++, response.data.entries.length > 0))) {
            _context.next = 25;
            break;
          }
          cov_vpxeygri4().b[8][0]++;
          // paging
          paginationUrls = (cov_vpxeygri4().s[30]++, []);
          _ref7 = (cov_vpxeygri4().s[31]++, response.data), entries = _ref7.entries;
          cov_vpxeygri4().s[32]++;
          for (i = (cov_vpxeygri4().s[33]++, 2); i <= response.data.pages; i += 1) {
            href = (cov_vpxeygri4().s[34]++, "".concat(rootUrl).concat(response.data.links.self));
            cov_vpxeygri4().s[35]++;
            paginationUrls.push(href.replace(/page=\d+/, "page=".concat(i)));
          }
          cov_vpxeygri4().s[36]++;
          _context.next = 18;
          return _promise["default"].all(paginationUrls.map(function (pu) {
            cov_vpxeygri4().f[8]++;
            cov_vpxeygri4().s[37]++;
            return _axios["default"].get(pu);
          }));
        case 18:
          pageResults = _context.sent;
          cov_vpxeygri4().s[38]++;
          entries = entries.concat(pageResults.map(function (e) {
            cov_vpxeygri4().f[9]++;
            cov_vpxeygri4().s[39]++;
            return e.data.entries;
          }).flat(1));
          cov_vpxeygri4().s[40]++;
          response.data.entries = entries;
          _context.next = 26;
          break;
        case 25:
          cov_vpxeygri4().b[8][1]++;
        case 26:
          cov_vpxeygri4().s[41]++;
          if (params.include) {
            cov_vpxeygri4().b[10][0]++;
            cov_vpxeygri4().s[42]++;
            // api will include refs
            response.data.entries = parseApiInclude(response.data.entries);
          } else {
            cov_vpxeygri4().b[10][1]++;
          }
          cov_vpxeygri4().s[43]++;
          return _context.abrupt("return", response);
        case 30:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function (_x) {
    return _ref5.apply(this, arguments);
  };
}();
cov_vpxeygri4().s[44]++;
Api.post = /*#__PURE__*/function () {
  var _ref8 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(path) {
    var unformattedBody,
      _ref9,
      _ref9$params,
      params,
      url,
      _args2 = arguments;
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          unformattedBody = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : (cov_vpxeygri4().b[11][0]++, {});
          _ref9 = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : (cov_vpxeygri4().b[12][0]++, {}), _ref9$params = _ref9.params, params = _ref9$params === void 0 ? (cov_vpxeygri4().b[13][0]++, {}) : _ref9$params;
          cov_vpxeygri4().f[10]++;
          url = (cov_vpxeygri4().s[45]++, getUrl(path));
          cov_vpxeygri4().s[46]++;
          return _context2.abrupt("return", _axios["default"].post(url, unformattedBody, {
            params: params
          }));
        case 6:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function (_x2) {
    return _ref8.apply(this, arguments);
  };
}();
cov_vpxeygri4().s[47]++;
Api.patch = /*#__PURE__*/function () {
  var _ref10 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3(path, id) {
    var unformattedBody,
      originalBody,
      _ref11,
      _ref11$params,
      params,
      date,
      url,
      lastUpdated,
      data,
      _args3 = arguments;
    return _regenerator["default"].wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          unformattedBody = _args3.length > 2 && _args3[2] !== undefined ? _args3[2] : (cov_vpxeygri4().b[14][0]++, {});
          originalBody = _args3.length > 3 ? _args3[3] : undefined;
          _ref11 = _args3.length > 4 && _args3[4] !== undefined ? _args3[4] : (cov_vpxeygri4().b[15][0]++, {}), _ref11$params = _ref11.params, params = _ref11$params === void 0 ? (cov_vpxeygri4().b[16][0]++, {}) : _ref11$params, date = _ref11.date;
          cov_vpxeygri4().f[11]++;
          url = (cov_vpxeygri4().s[48]++, getUrl("".concat(path, "/").concat(id))); // eslint-disable-next-line max-len
          lastUpdated = (cov_vpxeygri4().s[49]++, (cov_vpxeygri4().b[18][0]++, originalBody.metadata) && (cov_vpxeygri4().b[18][1]++, originalBody.metadata.lastUpdated) ? (cov_vpxeygri4().b[17][0]++, originalBody.metadata.lastUpdated) : (cov_vpxeygri4().b[17][1]++, date));
          cov_vpxeygri4().s[50]++;
          if (lastUpdated) {
            _context3.next = 13;
            break;
          }
          cov_vpxeygri4().b[19][0]++;
          cov_vpxeygri4().s[51]++;
          throw Error('PATCH: lastUpdated not provided in the body or in extras');
        case 13:
          cov_vpxeygri4().b[19][1]++;
        case 14:
          data = (cov_vpxeygri4().s[52]++, {
            metadata: {
              lastUpdated: lastUpdated
            },
            patch: (0, _fastJsonPatch.compare)(originalBody, unformattedBody)
          });
          cov_vpxeygri4().s[53]++;
          return _context3.abrupt("return", _axios["default"].patch(url, data, {
            params: params
          }));
        case 17:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function (_x3, _x4) {
    return _ref10.apply(this, arguments);
  };
}();
cov_vpxeygri4().s[54]++;
Api.remove = /*#__PURE__*/function () {
  var _ref12 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee4(path, id) {
    var _ref13,
      _ref13$params,
      params,
      _args4 = arguments;
    return _regenerator["default"].wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _ref13 = _args4.length > 2 && _args4[2] !== undefined ? _args4[2] : (cov_vpxeygri4().b[20][0]++, {}), _ref13$params = _ref13.params, params = _ref13$params === void 0 ? (cov_vpxeygri4().b[21][0]++, '') : _ref13$params;
          cov_vpxeygri4().f[12]++;
          cov_vpxeygri4().s[55]++;
          return _context4.abrupt("return", _axios["default"]["delete"](getUrl("".concat(path, "/").concat(id, "?").concat(params))));
        case 4:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return function (_x5, _x6) {
    return _ref12.apply(this, arguments);
  };
}();
cov_vpxeygri4().s[56]++;
Api.getByRef = function (ref, extras) {
  cov_vpxeygri4().f[13]++;
  cov_vpxeygri4().s[57]++;
  return Api.get("/api/".concat(ref), extras);
};
var _default = exports["default"] = Api;
cov_vpxeygri4().s[58]++;
var createBaseOperations = exports.createBaseOperations = function createBaseOperations(path) {
  cov_vpxeygri4().f[14]++;
  cov_vpxeygri4().s[59]++;
  return {
    get: function get(extras) {
      cov_vpxeygri4().f[15]++;
      cov_vpxeygri4().s[60]++;
      return Api.get(path, extras);
    },
    getById: function getById(id, extras) {
      cov_vpxeygri4().f[16]++;
      cov_vpxeygri4().s[61]++;
      return Api.get("".concat(path, "/").concat(id), extras);
    },
    getByIdWOP: function getByIdWOP(id, op, extras) {
      cov_vpxeygri4().f[17]++;
      cov_vpxeygri4().s[62]++;
      return Api.get("".concat(path, "/").concat(id, "/").concat(op), extras);
    },
    getByRef: Api.getByRef,
    getWOP: function getWOP(op, extras) {
      cov_vpxeygri4().f[18]++;
      cov_vpxeygri4().s[63]++;
      return Api.get("".concat(path, "/").concat(op), extras);
    },
    post: function post(body, extras) {
      cov_vpxeygri4().f[19]++;
      cov_vpxeygri4().s[64]++;
      return Api.post(path, body, extras);
    },
    postWOP: function postWOP(op, body, extras) {
      cov_vpxeygri4().f[20]++;
      cov_vpxeygri4().s[65]++;
      return Api.post("".concat(path, "/").concat(op), body, extras);
    },
    postByIdWOP: function postByIdWOP(id, op, body, extras) {
      cov_vpxeygri4().f[21]++;
      cov_vpxeygri4().s[66]++;
      return Api.post("".concat(path, "/").concat(id, "/").concat(op), body, extras);
    },
    patch: function patch(id, body, originalBody, extras) {
      cov_vpxeygri4().f[22]++;
      cov_vpxeygri4().s[67]++;
      return Api.patch(path, id, body, originalBody, extras);
    },
    patchByIdWOP: function patchByIdWOP(id, op, body, originalBody, extras) {
      cov_vpxeygri4().f[23]++;
      cov_vpxeygri4().s[68]++;
      return Api.patch(path, "".concat(id, "/").concat(op), body, originalBody, extras);
    },
    "delete": function _delete(id, extras) {
      cov_vpxeygri4().f[24]++;
      cov_vpxeygri4().s[69]++;
      return Api.remove(path, id, extras);
    },
    deleteByIdWOP: function deleteByIdWOP(id, op, extras) {
      cov_vpxeygri4().f[25]++;
      cov_vpxeygri4().s[70]++;
      return Api.remove(path, "".concat(id, "/").concat(op), extras);
    }
  };
};